<template>
  <div class="freightInquiryDetail">
    <div class="content" v-if="tableList && tableList.length > 0">
      <div class="table" v-for="(table, index) in tableList" :key="index">
        <van-collapse v-model="activeNames">
          <van-collapse-item :name="index">
            <template #title>
              <div class="table-title">
                <div class="table-title-image">
                  <van-image
                    class="logoImg"
                    :src="imgUrlFilter(table.LogoIcon)"
                    v-if="table.LogoIcon"
                  ></van-image>
                  <van-image class="logoImg" :src="planeIcon" v-else></van-image>
                </div>
                <div class="table-title-text">
                  <span v-if="language == 'zh'">{{ table.CargoCategory }}</span>
                  <span v-else>{{ table.CargoCategoryEn }}</span>
                </div>
              </div>
              <div class="table-subTitle">
                <div class="table-item">
                  <div class="table-item-left">
                    <van-image width="20" height="20" :src="boxIcon"></van-image>
                    <span class="label">{{ $t.freightInquiry.col2 }}</span>
                  </div>
                  <div class="table-item-right">
                    {{ table.FirstWeight }}<span v-if="table.WeightUnit == 1">KG</span
                    ><span v-if="table.WeightUnit == 2">cbm</span>
                  </div>
                </div>
                <div class="table-item">
                  <div class="table-item-left">
                    <van-image width="20" height="20" :src="moneyIcon"></van-image>
                    <span class="label">{{ $t.freightInquiry.col3 }}</span>
                  </div>
                  <div class="table-item-right">
                    {{ table.CurrencySymbol }}{{ table.FirstWeightPrice }}
                  </div>
                </div>
                <van-divider :hairline="false">{{
                  $t.freightInquiry.divider
                }}</van-divider>
                <div class="table-item">
                  <div class="table-item-left">
                    <van-image width="20" height="20" :src="boxIcon"></van-image>
                    <span class="label">{{ $t.freightInquiry.col4 }}</span>
                  </div>
                  <div class="table-item-right">
                    {{ table.ContinuousWeight
                    }}<span v-if="table.WeightUnit == 1">KG</span
                    ><span v-if="table.WeightUnit == 2">cbm</span>
                  </div>
                </div>
                <div class="table-item">
                  <div class="table-item-left">
                    <van-image width="20" height="20" :src="moneyIcon"></van-image>
                    <span class="label">{{ $t.freightInquiry.col5 }}</span>
                  </div>
                  <div class="table-item-right">
                    {{ table.CurrencySymbol }}{{ table.ContinuousWeightPrice }}
                  </div>
                </div>
                <div class="table-item">
                  <div class="table-item-left">
                    <van-image width="20" height="20" :src="timeIcon"></van-image>
                    <span class="label">{{ $t.freightInquiry.col6 }}</span>
                  </div>
                  <div class="table-item-right">
                    {{ table.TransportationDuration }}{{ $t.freightInquiry.day }}
                  </div>
                </div>
                <div class="table-item" v-if="isShowRemark(table)">
                  <div class="table-remark-left">
                    <van-image width="20" height="20" :src="remarkIcon"></van-image>
                    <span class="label">{{ $t.freightInquiry.remark }}</span>
                  </div>
                  <div class="table-remark-right">
                    <span v-if="language == 'zh'">{{ table.Remark }}</span>
                    <span v-else>{{ table.RemarkEn }}</span>
                  </div>
                </div>
              </div>
            </template>

            <div class="table-wrapper1">
              <div class="table-row">
                <div class="table-row-left">
                  <div class="table-row-image">
                    <van-image width="15" height="15" :src="contactIcon"></van-image>
                  </div>
                </div>
                <div class="table-row-right">
                  <div class="table-row-value">{{ table.WarehouseContact1 }}</div>
                  <div class="table-row-label">
                    {{ $t.freightInquiry.warehouseContact }}
                  </div>
                </div>
              </div>

              <div class="table-row">
                <div class="table-row-left">
                  <div class="table-row-image">
                    <van-image width="15" height="15" :src="phoneIcon"></van-image>
                  </div>
                </div>
                <div class="table-row-right">
                  <div class="table-row-value">{{ table.WarehouseContactPhone }}</div>
                  <div class="table-row-label">
                    {{ $t.freightInquiry.warehousePhone }}
                  </div>
                </div>
              </div>
            </div>

            <div class="table-wrapper2">
              <div class="table-row-left">
                <div class="table-row-image">
                  <van-image width="15" height="15" :src="locationIcon"></van-image>
                </div>
              </div>
              <div class="table-row-right">
                <div class="table-row-value">{{ table.WarehouseAddress }}</div>
              </div>
            </div>

            <div class="table-buttons">
              <van-button
                block
                type="info"
                color="#2750aa"
                :icon="copyIcon"
                size="small"
                style="border-radius: 10px"
                @click="onCopy(table)"
                >{{ $t.freightInquiry.copy }}</van-button
              >
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
    <div v-else class="emptyTable">{{ $t.freightInquiry.empty }}</div>

    <div class="tool-bar">
      <van-button block :icon="calculatorIcon" @click="gotoCalculator">{{
        $t.home.freightPriceCalculator
      }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Button, Collapse, CollapseItem, Image, Divider } from "vant";

Vue.use(Button).use(Collapse).use(CollapseItem).use(Image).use(Divider);
export default {
  name: "freightInquiryDetail",
  components: {},
  data() {
    return {
      planeIcon: require("@/assets/img/freightInquiry/plane.png"),
      boxIcon: require("@/assets/img/freightInquiry/box.png"),
      moneyIcon: require("@/assets/img/freightInquiry/money.png"),
      timeIcon: require("@/assets/img/freightInquiry/time.png"),
      remarkIcon: require("@/assets/img/freightInquiry/remark.png"),
      contactIcon: require("@/assets/img/freightInquiry/contact.png"),
      phoneIcon: require("@/assets/img/freightInquiry/phone.png"),
      locationIcon: require("@/assets/img/freightInquiry/location.png"),
      copyIcon: require("@/assets/img/freightInquiry/copy.png"),
      calculatorIcon: require("@/assets/img/freightInquiry/calculator.png"),
      language: localStorage.getItem("requestLanguage") || "auto",
      FPId: "",
      tableList: [],
      activeNames: [],
    };
  },
  created() {
    const query = this.$route.query;
    if (query.FPId) {
      this.FPId = query.FPId;
      this.loadFreightPriceInfo();
    }
  },
  methods: {
    gotoCalculator() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "freightPriceCalculator",
        name: "freightPriceCalculator",
        query: [],
      });
    },
    isShowRemark(table) {
      if (this.language == "zh") {
        if (table.Remark) return true;
      } else {
        if (table.RemarkEn) return true;
      }
      return false;
    },
    loadFreightPriceInfo() {
      this.$commonMethod.showLoading();
      var param = {
        FPId: this.FPId,
      };
      return new Promise((resolve) => {
        this.$api.customerManagement
          .loadFreightPriceInfo(param)
          .then((res) => {
            this.tableList = res.data.DetailList;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onCopy(value) {
      var text =
        this.$t.freightInquiry.warehouseContact +
        "：" +
        (value.WarehouseContact1
          ? value.WarehouseContact1
          : this.$t.freightInquiry.none) +
        " , " +
        this.$t.freightInquiry.warehousePhone +
        "：" +
        (value.WarehouseContactPhone
          ? value.WarehouseContactPhone
          : this.$t.freightInquiry.none) +
        " , " +
        this.$t.freightInquiry.warehouseAddress +
        "：" +
        (value.WarehouseAddress ? value.WarehouseAddress : this.$t.freightInquiry.none);
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.cargoInquiry.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.freightInquiryDetail {
  .content {
    width: 100%;
    display: inline-block;
    ::v-deep .van-collapse-item__content {
      padding: 0px 10px 10px 10px !important;
    }
    ::v-deep .van-collapse-item::after {
      border: none !important;
    }
    .van-collapse-item {
      ::v-deep .van-collapse-item__title {
        padding: 10px 10px 0px 10px;
        display: block !important;
      }
      ::v-deep .van-icon-arrow {
        width: 100%;
        text-align: center;
        color: #000;
        margin: 0;
      }
      ::v-deep .van-cell:after {
        border: none !important;
      }
    }
    .table {
      width: 95%;
      margin: 2% auto auto auto;
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
      .table-title {
        background: #e4e9f3;
        color: #1b347c;
        padding: 8px 10px;
        border-radius: 10px;
        .table-title-image {
          display: inline-block;
          vertical-align: middle;
          width: 30px;
          height: 30px;
          border-radius: 100px;
          margin-right: 10px;
          .logoImg {
            ::v-deep .van-image__img {
              width: 30px;
              height: 30px;
              border-radius: 100px;
              object-fit: cover;
            }
          }
        }
        .table-title-text {
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
          font-weight: 500;
        }
      }
      .table-subTitle {
        margin-top: 10px;
        border: 1px solid #ebedf0;
        border-radius: 20px;
        padding: 10px 15px 0px 15px;
        .van-divider {
          font-size: 12px;
          margin: 0px 0px 10px 0px;
        }
        .table-item {
          padding-bottom: 10px;
          .table-item-left {
            display: inline-block;
            vertical-align: middle;
            width: 60%;
            color: #000;
            font-size: 12px;
            font-weight: 500;
            .van-image {
              display: inline-block;
              vertical-align: middle;
              margin-right: 5px;
            }
            .label {
              display: inline-block;
              vertical-align: middle;
            }
          }
          .table-item-right {
            display: inline-block;
            vertical-align: middle;
            width: 40%;
            color: orange;
            font-size: 12px;
            text-align: right;
            font-weight: 500;
          }
          .table-remark-left {
            display: inline-block;
            vertical-align: middle;
            width: 40%;
            color: #000;
            font-size: 12px;
            font-weight: 500;
            .van-image {
              display: inline-block;
              vertical-align: middle;
              margin-right: 5px;
            }
            .label {
              display: inline-block;
              vertical-align: middle;
            }
          }
          .table-remark-right {
            display: inline-block;
            vertical-align: middle;
            width: 60%;
            line-height: 15px;
            color: #666;
            font-size: 12px;
            text-align: right;
            font-weight: 500;
          }
        }
      }
    }
    .table-wrapper1 {
      margin-bottom: 10px;
      padding: 8px 8px 8px 0px;
      background: #f8f9fe;
      border-radius: 20px;
      border: 1px solid #ebedf0;
      .table-row:last-child {
        margin-bottom: 0px !important;
      }
      .table-row {
        margin-bottom: 10px;
        .table-row-left {
          display: inline-block;
          vertical-align: middle;
          width: 20%;
          text-align: center;
          .table-row-image {
            background: #e4e9f3;
            border-radius: 100px;
            width: 30px;
            height: 30px;
            line-height: 30px;
            margin: auto;
            .van-image {
              vertical-align: middle;
              margin-bottom: 3px;
              margin-right: 1px;
            }
          }
        }
        .table-row-right {
          display: inline-block;
          vertical-align: middle;
          width: 80%;
          text-align: left;
          .table-row-value {
            color: #000;
            font-weight: 500;
            font-size: 12px;
          }
          .table-row-label {
            color: #999;
            font-size: 12px;
          }
        }
      }
    }
    .table-wrapper2 {
      height: 50px;
      padding: 8px 8px 8px 0px;
      border-radius: 20px;
      border: 1px solid #ebedf0;
      .table-row-left {
        display: inline-block;
        vertical-align: top;
        width: 15%;
        text-align: center;
        .table-row-image {
          margin: auto;
        }
      }
      .table-row-right {
        display: inline-block;
        vertical-align: middle;
        width: 85%;
        text-align: left;
        .table-row-value {
          color: #000;
          font-weight: 500;
          font-size: 12px;
        }
      }
    }
    .table-buttons {
      margin-top: 10px;
      text-align: center;
      .van-button {
        height: 40px;
      }
      ::v-deep .van-button__text {
        font-size: 12px !important;
      }
      ::v-deep .van-icon__image {
        font-size: 12px !important;
      }
    }
  }
  .emptyTable {
    color: #999;
    font-size: 14px;
    background: #fff;
    text-align: center;
    padding: 20%;
    border: 1px solid #ebedf0;
  }
  .tool-bar {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 2.5%;
    z-index: 10;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      width: 90%;
      margin: auto;
      border: none;
      border-radius: 10px;
      color: #ffffff;
      background: #2750aa !important;
      .van-button__icon {
        margin-top: 2px;
      }
      .van-button__text {
        font-size: 14px !important;
      }
    }
  }
}
</style>
